export default "__VITE_ASSET__643u9A$h__"